module.exports = __webpack_public_path__ + "static/라면면류-962944ae2fa49ae66868124fe7e16c5d.png";